import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// Import Containers
import { FullLayout, SimpleLayout } from "./containers";
import { AuthGuard } from "./_guards/auth.guard";
import { P404Component } from "./views/pages/404.component";
import { AuthProjectGuard } from "./_guards/auth-project.guard";
import { AuthAdminGuard } from "./_guards";
import { ConfigPermissionOption } from "./_helpers/config-permission-option";
import { AuthPermissionGuard } from "./_guards/auth-permission.guard";
export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "dashboards",
    component: SimpleLayout,
    data: {
      title: "Dashboards",
    },
    children: [
      {
        path: "",
        loadChildren: "./views/dashboards/dashboards.module#DashboardsModule",
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: "",
    component: FullLayout,
    children: [
      {
        path: "dashboard",
        loadChildren: "./views/dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "components",
        loadChildren: "./views/components/components.module#ComponentsModule",
      },
      {
        path: "icons",
        loadChildren: "./views/icons/icons.module#IconsModule",
      },
      {
        path: "widgets",
        loadChildren: "./views/widgets/widgets.module#WidgetsModule",
      },
      {
        path: "charts",
        loadChildren: "./views/chartjs/chartjs.module#ChartJSModule",
      },
      {
        path: "comments",
        loadChildren: "./views/comments/comments.module#CommentsModule",
      },
      {
        path: "posts",
        loadChildren: "./views/posts/posts.module#PostsModule",
        canActivate: [AuthProjectGuard],
      },
      {
        path: "demo",
        loadChildren: "./views/main-page/main-page.module#MainPageModule",
      },
      {
        path: "trending",
        loadChildren:
          "./views/keyword-analysis/keyword-analysis.module#KeywordAnalysisModule",
      },
      {
        path: "system",
        loadChildren: "./views/system/system.module#SystemModule",
      },
      {
        path: "auto-seeding",
        loadChildren:
          "./views/auto-seeding/auto-seeding.module#AutoSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAutoSeeding,
        },
      },
      {
        path: "auto-like-page",
        loadChildren:
          "./views/auto-seeding/auto-seeding.module#AutoSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAutoLikePage,
        },
      },
      {
        path: "auto-follow-user",
        loadChildren:
          "./views/auto-seeding/auto-seeding.module#AutoSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAutoFollowUser,
        },
      },
      {
        path: "auto-like-post",
        loadChildren:
          "./views/auto-seeding/auto-seeding.module#AutoSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAutoLikePost,
        },
      },
      {
        path: "auto-like-comment",
        loadChildren:
          "./views/auto-seeding/auto-seeding.module#AutoSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAutoLikeComment,
        },
      },
      {
        path: "auto-share",
        loadChildren:
          "./views/auto-seeding/auto-seeding.module#AutoSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAutoShare,
        },
      },
      {
        path: "auto-comment",
        loadChildren:
          "./views/auto-seeding/auto-seeding.module#AutoSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAutoComment,
        },
      },
      {
        path: "auto-post",
        loadChildren:
          "./views/auto-seeding/auto-seeding.module#AutoSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAutoPost,
        },
      },
      {
        path: "auto-join-group",
        loadChildren:
          "./views/auto-seeding/auto-seeding.module#AutoSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAutoJoinGroup,
        },
      },
      {
        path: "auto-dynamic-script",
        loadChildren:
          "./views/auto-seeding/auto-seeding.module#AutoSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAutoDynamicScript,
        },
      },
      // thanhdv
      {
        path: "report",
        loadChildren: "./views/report/report.module#ReportModule",
      },
      {
        path: "account",
        loadChildren: "./views/account/account.module#AccountModule",
      },
      {
        path: "application",
        loadChildren: "./application/application.module#ApplicationModule",
      },
      {
        path: "post-management",
        loadChildren:
          "./views/post-management/post-management.module#PostManagementModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPostManagement,
        },
      },
      {
        path: "e14-sentiment-report",
        loadChildren:
          "./views/e14-report/sentiment-report/sentiment-report.module#E14SentimentReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionE14Report,
        },
      },
      {
        path: "e14-top-content-report",
        loadChildren:
          "./views/e14-report/top-content-report/top-content-report.module#E14TopContentReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionE14Report,
        },
      },
      {
        path: "ttdt-report",
        loadChildren:
          "./views/pttt-reports/ttdt-report/ttdt-report.module#TTDTReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPTTTReport,
        },
      },
      {
        path: "keyword-report",
        loadChildren:
          "./views/pttt-reports/keyword-report/keyword-report.module#KEYWORDReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPTTTReport,
        },
      },
      {
        path: "fanpage-report",
        loadChildren:
          "./views/pttt-reports/fanpage-report/fanpage-report.module#FANPAGEReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPTTTReport,
        },
      },
      {
        path: "dgdv-report",
        loadChildren:
          "./views/pttt-reports/dgdv-report/dgdv-report.module#DGDVReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPTTTReport,
        },
      },
      {
        path: "dgcd-report",
        loadChildren:
          "./views/pttt-reports/dgcd-report/dgcd-report.module#DGCDReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPTTTReport,
        },
      },
      {
        path: "tkhd-report",
        loadChildren:
          "./views/pttt-reports/tkhd-report/tkhd-report.module#TKHDReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPTTTReport,
        },
      },
      {
        path: "lhbd-report",
        loadChildren:
          "./views/pttt-reports/lhbd-report/lhbd-report.module#LHBDReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPTTTReport,
        },
      },
      {
        path: "post-negative",
        loadChildren:
          "./views/post-negative/post-negative.module#PostNegativeModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPostNegative,
        },
      },
      {
        path: "projects",
        loadChildren: "./projects/projects.module#ProjectsModule",
      },
      {
        path: "project/:id",
        loadChildren: "./project/project.module#ProjectModule",
      },
      {
        path: "articles/:domain",
        loadChildren: "./views/articles/articles.module#ArticlesModule",
        canActivate: [AuthProjectGuard],
      },
      {
        path: "group-posts",
        loadChildren: "./views/group-posts/group-posts.module#GroupPostsModule",
      },
      {
        path: "pages",
        loadChildren: "./views/page/page.module#PageModule",
      },
      {
        path: "groups",
        loadChildren: "./views/group/group.module#GroupModule",
      },
      {
        path: "users",
        loadChildren: "./views/user/user.module#UserModule",
      },
      {
        path: "fb-users",
        loadChildren: "./views/fb-users/fb-users.module#FBUsersModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionScanAccountManagement,
        },
      },
      {
        path: "tokens",
        loadChildren: "./views/token/tokens.module#TokensModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionTokenManagement,
        },
      },
      {
        path: "fb-users-priority",
        loadChildren:
          "./views/fb-users-priority/fb-users-priority.module#FBUsersPriorityModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPriorityListManagement,
        },
      },
      {
        path: "youtube",
        loadChildren: "./views/youtube/youtube.module#YoutubeModule",
      },
      {
        path: "permission",
        loadChildren:
          "./views/system/permission/permission.module#PermissionModule",
      },

      {
        path: "fb-user-seeding",
        loadChildren:
          "./views/fb-user-seeding/fb-user-seeding.module#FbUserSeedingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: [
            ConfigPermissionOption.actionSeedingAccountManager,
            ConfigPermissionOption.actionViewSeedingAccount,
          ],
        },
      },
      {
        path: "log-management",
        loadChildren:
          "./views/log-management/log-management.module#LogManagementModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionLogManagement,
        },
      },
      {
        path: "user-time-report",
        loadChildren:
          "./views/user-time-report/user-time-report.module#UserTimeReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionUserTimeReport,
        },
      },
      {
        path: "provinces",
        loadChildren: "./views/provinces/provinces.module#ProvincesModule",
        canActivate: [AuthAdminGuard],
      },
      {
        path: "follows",
        loadChildren: "./views/follows/follows.module#FollowsModule",
        canActivate: [AuthAdminGuard],
      },
      {
        path: "work-report",
        loadChildren: "./views/work-report/work-report.module#WorkReportModule",
      },
      {
        path: "news-report",
        loadChildren: "./views/news-report/news-report.module#NewsReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionNewsReport,
        },
      },
      {
        path: "crawler-report",
        loadChildren:
          "./views/crawler-report/crawler-report.module#CrawlerReportModule",
        canActivate: [AuthAdminGuard],
        data: {
          permission: ConfigPermissionOption.actionCrawlerReport,
        },
      },
      {
        path: "news-analytic",
        loadChildren:
          "./views/news-analytic/news-analytic.module#NewsAnalyticModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionConfigNewsAnalytic,
        },
      },
      {
        path: "brands",
        loadChildren: "./views/brands/brands.module#BrandsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: [ConfigPermissionOption.actionBrands],
        },
      },
      {
        path: "group-discussion",
        loadChildren:
          "./views/group-discussion/group-discussion.module#GroupDiscussionModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionGroupDiscussion,
        },
      },
      {
        path: "report-manager",
        loadChildren:
          "./views/report-manager/report-manager.module#ReportManagerModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionReportManager,
        },
      },
      {
        path: "re-scan",
        loadChildren:
          "./views/rescan-configs/rescan-configs.module#ReScanConfigsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionReScan,
        },
      },
      {
        path: "token-management",
        loadChildren:
          "./views/token-management/token-management.module#TokenManagementModule",
        canActivate: [AuthAdminGuard],
      },
      {
        path: "seeding-positive-report",
        loadChildren:
          "./views/seeding-positive-report/seeding-positive-report.module#SeedingPositiveReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionSeedingBotReport,
        },
      },
      {
        path: "tiktok-management",
        loadChildren:
          "./views/tiktok-management/tiktok-management.module#TiktokManagementModule",
        canActivate: [AuthAdminGuard],
      },
      {
        path: "twitter-management",
        loadChildren:
          "./views/twitter-management/twitter-management.module#TwitterManagementModule",
        canActivate: [AuthAdminGuard],
      },
      {
        path: "instagram-management",
        loadChildren:
          "./views/instagram-management/instagram-management.module#InstagramManagementModule",
        canActivate: [AuthAdminGuard],
      },
      {
        path: "pack-management",
        loadChildren:
          "./views/pack-management/pack-management.module#PackManagementModule",
        canActivate: [AuthAdminGuard],
      },
      {
        path: "negative-post-late",
        loadChildren:
          "./views/negative-post-late/negative-post-late.module#NegativePostLateModule",
        canActivate: [AuthAdminGuard],
      },
      {
        path: "token-facebook-status",
        loadChildren:
          "./views/token-facebook-status/token-facebook-status.module#TokenFacebookStatusModule",
        canActivate: [AuthAdminGuard],
      },
      {
        path: "add-token-log",
        loadChildren:
          "./views/add-token-log/add-token-log.module#AddTokenLogModule",
        canActivate: [AuthAdminGuard],
      },
      {
        path: "news-management",
        loadChildren:
          "./views/news-management/news-management.module#NewsManagementModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: [
            ConfigPermissionOption.actionNewsSource,
            ConfigPermissionOption.actionCreateNewsConfig,
          ],
        },
      },
      {
        path: "linkedin-management",
        loadChildren:
          "./views/linkedin-management/linkedin-management.module#LinkedinManagementModule",
        canActivate: [AuthAdminGuard],
      },

      {
        path: "article-reports",
        loadChildren:
          "./views/article-reports/article-reports.module#ArticleReportsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionArticleReport,
        },
      },
      {
        path: "top-facebook-report",
        loadChildren:
          "./views/top-facebook-report/top-facebook-report.module#TopFacebookReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionTopFacebookReport,
        },
      },
      {
        path: "weekly-report",
        loadChildren:
          "./views/weekly-report/weekly-report.module#WeeklyReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionWeeklyReport,
        },
      },
      {
        path: "negative-report",
        loadChildren:
          "./views/negative-report/negative-report.module#NegativeReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionNegativeReport,
        },
      },
      {
        path: "add-posts",
        loadChildren: "./views/add-posts/add-posts.module#AddPostsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionAddPosts,
        },
      },
      {
        path: "comment-management",
        loadChildren:
          "./views/comment-management/comment-management.module#CommentManagementModule",
      },
      {
        path: "customer-contents",
        loadChildren:
          "./views/customer-contents/customer-contents.module#CustomerContentModule",
      },
      {
        path: "vps-hosting",
        loadChildren: "./views/vps-hosting/vps-hosting.module#VPSHostingModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionVPSHostingManagement,
        },
      },
      {
        path: "brand-manage",
        loadChildren: "./views/brand-manage/brands.module#BrandsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: [ConfigPermissionOption.actionBrandManage],
        },
      },
      {
        path: "role-brands",
        loadChildren:
          "./views/reports-module/role-brands/role-brands.module#RoleBrandsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: [ConfigPermissionOption.actionRoleBrand],
        },
      },
      {
        path: "brand-report",
        loadChildren:
          "./views/reports-module/brand-report/brand-reports.module#BrandReportsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionBrandReport,
        },
      },
      {
        path: "brand-data-source-report",
        loadChildren:
          "./views/reports-module/brand-data-source/brand-data-source-reports.module#BrandDataSourceReportsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionBrandDataSource,
        },
      },
      {
        path: "sentiment-report",
        loadChildren:
          "./views/reports-module/sentiment-report/sentiment-reports.module#SentimentReportsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionSentimentDiscussReport,
        },
      },
      {
        path: "detail-report",
        loadChildren:
          "./views/reports-module/detail-report/detail-reports.module#DetailReportsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionDetailReport,
        },
      },
      {
        path: "top-content-discuss",
        loadChildren:
          "./views/reports-module/top-content-discuss/top-content-discuss.module#TopContentDiscussModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionTopContentDiscuss,
        },
      },
      {
        path: "discussion-development",
        loadChildren:
          "./views/reports-module/discussion-development/discussion-development-reports.module#DiscussionDevelopmentReportsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionDiscussionDevelopment,
        },
      },
      {
        path: "featured-content",
        loadChildren:
          "./views/reports-module/featured-content/featured-content.module#FeatureContentModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionFeaturedContent,
        },
      },
      {
        path: "brand-comparison",
        loadChildren:
          "./views/reports-module/brand-comparison/brand-comparison-reports.module#BrandComparisonReportsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionBrandComparison,
        },
      },
      {
        path: "outstanding-statistics",
        loadChildren:
          "./views/reports-module/outstanding-statistics/outstanding-statistics.module#OutstandingStatisticsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionOutstandingStatistics,
        },
      },
      {
        path: "channel-discussion",
        loadChildren:
          "./views/reports-module/channel-discussion/channel-discussion.module#ChannelDiscussionModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionChannelDiscussion,
        },
      },
      {
        path: "page-analytic",
        loadChildren:
          "./views/reports-module/page-analytic/page-analytic.module#PageAnalyticModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionPageAnalytic,
        },
      },
      {
        path: "user-overview",
        loadChildren:
          "./views/reports-module/user-overview/user-overview.module#UserOverviewModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionUserOverview,
        },
      },
      {
        path: "compare-page-analytic",
        loadChildren:
          "./views/reports-module/compare-page-analytic/compare-page-analytic.module#ComparePageAnalyticModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionComparePageAnalytic,
        },
      },
      {
        path: "compare-source",
        loadChildren:
          "./views/reports-module/compare-source/compare-source.module#CompareSourceModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionCompareSource,
        },
      },
      {
        path: "discussion-development-brands",
        loadChildren:
          "./views/reports-module/discussion-development-brands/discussion-development-brands.module#DiscussionDevelopmentBrandsModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionDiscussDevelopmentBrands,
        },
      },
      {
        path: "sentiment-brand-report",
        loadChildren:
          "./views/reports-module/sentiment-brands-report/sentiment-brand-report.module#SentimentBrandReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionSentimentBrandReport,
        },
      },
      {
        path: "table-content",
        loadChildren:
          "./views/reports-module/table-content/table-content.module#TableContentModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionTableContent,
        },
      },

      //badv
      {
        path: "potential-customers",
        loadChildren:
          "./views/potential-customers/potential-customers.module#PotentialCustomersModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionRequestProcessing,
        },
      },
      {
        path: "potential-customers-report",
        loadChildren:
          "./views/potential-customers-report/potential-customers-report.module#PotentialCustomersReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionExploitationReport,
        },
      },

      {
        path: "potential-customers-detail",
        loadChildren:
          "./views/potential-customers-detail/potential-customers-detail.module#PotentialCustomersDetailModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionRequestProcessing,
        },
      },
      {
        path: "potential-customers-order-list",
        loadChildren:
          "./views/potential-customers-order-list/potential-customers-order-list.module#PotentialCustomersOrderListModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionCreatedOrder,
        },
      },
      {
        path: "performance-report",
        loadChildren:
          "./views/performance-report/performance-report.module#PerformanceReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionReportWorkPerformance,
        },
      },
      {
        path: "consulting-history",
        loadChildren:
          "./views/consulting-history/consulting-history.module#ConsultingHistoryModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionConsultingHistory,
        },
      },
      {
        path: "health-brand",
        loadChildren:
          "./views/reports-module/health-brand/health-brand.module#HealthBrandModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionHealthBrand,
        },
      },
      {
        path: "discussion-market-share",
        loadChildren:
          "./views/reports-module/discussion-market-share/discussion-market-share.module#DiscussionMarketShareModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionDiscussionMarketShare,
        },
      },
      {
        path: "compare-page-analytic",
        loadChildren:
          "./views/reports-module/compare-page-analytic/compare-page-analytic.module#ComparePageAnalyticModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionComparePageAnalytic,
        },
      },
      {
        path: "discussion-total-report",
        loadChildren:
          "./views/reports-module/discussion-total-report/discussion-total-report.module#DiscussionTotalReportModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionDiscussionTotalReport,
        },
      },
      {
        path: "discussion-tv-social",
        loadChildren:
          "./views/reports-module/discussion-tv-social/discussion-tv-social.module#DiscussionTVSocialModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionDiscussionTvSocial,
        },
      },
      {
        path: "discussion-trend",
        loadChildren:
          "./views/reports-module/discussion-trend/discussion-trend.module#DiscussionTrendModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionTopContentDiscuss,
        },
      },
      {
        path: "sentiment-index",
        loadChildren:
          "./views/reports-module/sentiment-index/sentiment-index.module#SentimentIndexModule",
        canActivate: [AuthPermissionGuard],
        data: {
          permission: ConfigPermissionOption.actionSentimentIndex,
        },
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: "layout",
    component: SimpleLayout,
    data: {
      title: "Pages",
    },
    children: [
      {
        path: "",
        loadChildren: "./views/pages/pages.module#PagesModule",
      },
    ],
  },
  {
    path: "auth",
    component: SimpleLayout,
    data: {
      title: "Auth",
    },
    children: [
      {
        path: "",
        loadChildren: "./views/auth/auth.module#AuthModule",
      },
    ],
  },
  {
    path: "reset",
    component: SimpleLayout,
    data: {
      title: "",
    },
    children: [
      {
        path: "",
        loadChildren:
          "./views/account/account-reset-password/account-reset-password.module#AccountResetPasswordModule",
      },
    ],
  },
  {
    path: "**",
    component: P404Component,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/app.routing.ts